import React from "react";
import { Flex, Box } from "reflexbox";
import styled from "styled-components";

import * as colors from "../styles/colors";
import { content } from "../services/contentful";

const Bar = styled(Flex)`
  & a {
    color: ${colors.dark};
    text-decoration: underline !important;
    box-shadow: none;
    font-size: inherit;
    margin: 0;
    text-decoration: inherit;
    letter-spacing: inherit;
    line-height: inherit;
    font-weight: inherit;

    &:focus {
      box-shadow: none;
    }
  }
`;

export function AnnouncementBar({ announcementBar }) {
  const { show } = announcementBar ?? { show: false };
  const { json } = content(announcementBar);

  if (!show) {
    return null;
  }

  return (
    <Bar
      as="aside"
      role="banner"
      py={["8px"]}
      px={["12px"]}
      alignItems="center"
      flexDirection="column"
      style={{
        background: colors.blueGradient,
        width: "100%"
      }}
    >
      <Box
        fontSize="14px"
        color="black"
        fontFamily={`"Eina02-SemiBold", sans-serif !important;`}
        textAlign="center"
        py={[2]}
        px={[3]}
        sx={{
          letterSpacing: ["-0.7px", 0]
        }}
      >
        {json("content", "announcementBarOptions")}
      </Box>
    </Bar>
  );
}
